// prettier-ignore

const fiTranslations = {
	"title": "Palvelupaketin tilaus",
	"companyBasicInformationTitle": "Yrityksen perustiedot",
	"thanYouForContacting": "Kiitos yhteydenotostasi, olemme sinuun pian yhteydessä!",
	"previous": "Edellinen",
	"next": "Seuraava",
	"cancel": "Keskeytä",
	"continueOrder": "Jatka tilausta",
	"cancelConfirmationTitle": "Olet keskeyttämässä tilausta. Keskeyttämällä kaikki tiedot poistetaan.",
	"cancelConfirmationQuestion": "Haluatko varmasti keskeyttää tilauksen?",
	"return": "Palaa",
	"returnToAsiakastieto": "Palaa Asiakastiedon sivuille",
	"continue": "Jatka",
	"send": "Lähetä",
	"unexpectedError": "Virhetilanne",
	"formDataLoadingFailed": "Tietojen lataus epäonnistui.",
	"companyCheckFailed": "Yrityksen tietojen tarkastus epäonnistui.",
	"requiredField": "Pakollinen kenttä",
	"invalidEmail": "Virheellinen sähköpostiosoite",
	"emailsDontMatch": "Sähköpostiosoitteet eivät täsmää",
	"companyName": "Yrityksen nimi",
	"companyId": "Y-tunnus",
	"streetAddress": "Postiosoite",
	"postalCode": "Postinumero",
	"invalidPostalCode": "Virheellinen postinumero",
	"city": "Postitoimipaikka",
	"email": "Sähköpostiosoite",
	"emailRepeat": "Sähköpostiosoite uudelleen",
	"firstName": "Etunimi",
	"lastName": "Sukunimi",
	"phone": "Puhelinnumero",
	"invalidPhone": "Virheellinen puhelinnumero",
	"companySearchDiscontinued": "LAKANNUT",
	"invalidCompanySelection": "Virheelliset yritystiedot",
	"companySearchLabel": "Yrityksen nimi tai y-tunnus",
	"companyDiscontinued": "Tämän yrityksen toiminta on lakannut",
	"companySearchPlaceholder": "Hae yrityksen nimellä tai y-tunnuksella...",
	"identificationTitle": "Tunnistautuminen",
	"companyCheckSuccess": "Pyydämme vielä vahvistamaan yrityksen nimenkirjoitusoikeuden. Ole hyvä ja siirry eteenpäin. Kun olet tunnistautunut voimme jatkaa palvelupaketin valitsemisvaiheeseen.",
	"identify": "Tunnistaudu",
	"identificationError": "Virhe tunnistautumisessa. Ole hyvä ja yritä uudelleen.",
	"tooHighCreditRiskTitle": "Kiitos, että otit meihin yhteyttä. Arvostamme kiinnostustasi palveluamme kohtaan.",
	"tooHighCreditRiskContent": "Valitettavasti luottopolitiikkamme ei tällä hetkellä mahdollista palvelun tilaamista laskulla. Pahoittelemme mahdollista aiheutunutta vaivaa. Voit aina ostaa tuotteita <a href=\"https://www.asiakastieto.fi/yritykset\">verkkokaupassamme</a> suoraveloituksella.",
	"invalidCompanyText1": "Kiitos kiinnostuksestasi! Olemme <font color=\"red\">sinuun</font> pian yhteydessä",
	"invalidCompanyText2": "Emme voi valitettavasti tarjota sinulle sopimusta itsepalvelukanavassa, mutta myyntimme on sinuun yhteydessä, jotta saat tarpeitasi vastaavan ratkaisun käyttöösi",
	"invalidCompanyText3": "Täytä yhteystietosi alle, niin otamme yhteyttä",
	"invalidCompanyPleaseEnterContact": "Ole hyvä ja täytä yhteystietosi ja olemme sinuun pian yhteydessä.",
	"contactFormFailed": "Yhteydenottopyynnön jättäminen epäonnistui",
	"checkNoSignatureRight": "Valitettavasti tilaaminen ei ole mahdollista, koska nimenkirjoitusoikeus puuttuu.",
	"checkExistingCustomer": "Kiitos kiinnostuksestasi palveluamme kohtaan. Valitettavasti tilausta ei voitu käsitellä tällä hetkellä.",
	"checkActivityInterrupted": "Kiitos mielenkiinnostasi palveluamme kohtaan. Yrityksen toiminta on keskeytynyt, joten tilaaminen ei ole tällä hetkellä mahdollista.",
	"checkBankrupt": "Luottopolitiikkamme ei mahdollista tilausta.",
	"checkLiquidation": "Luottopolitiikkamme ei mahdollista tilausta.",
	"checkCompanyIndustry": "Kiitos kiinnostuksestasi palveluamme kohtaan. Valitettavasti yrityksen toimiala ei mahdollista tilaamista tällä hetkellä.",
	"checkTurnoverTooHigh": "Kiitos kiinnostuksestasi palveluamme kohtaan. Palvelu ei valitettavasti sovellu liikevaihdoltaan näin suurelle yritykselle.",
	"checkCompanyRegistrationIncomplete": "Kiitos kiinnostuksestasi palveluamme kohtaan. Koska yrityksen rekisteröinti on kesken, tilaaminen ei ole tällä hetkellä mahdollista.",
	"checkCreditRisk": "Luottopolitiikkamme ei mahdollista tilausta. Voit halutessasi olla yhteydessä asiakaspalveluumme.",
	"naviUsage": "Käyttötarve",
	"naviBasketSelection": "Palvelupaketin valinta",
	"naviOrderInfo": "Tilaajan tiedot",
	"naviSummary": "Tilauksen yhteenvetosivu",
	"naviFinished": "Tilaus valmis",
	"packageSelectionTitle": "Ole hyvä ja valitse paketti valitsemalla tarpeesi mukainen kuukausilimiitti",
	"packageSelectionContent": "Kuukausilimiitti kertoo raporttien hakumäärän kuukauden aikana (20, 40 tai 60). Mikäli tilausjakson aikana tarvitset enemmän raportteja kuin valitsemasi paketti sallii voit ostaa näitä eri veloituksella.",
	"typeMICRO": "Micro",
	"typeSMALL": "Small",
	"typeCOMPACT": "Compact",
	"priceMICRO": "49",
	"priceSMALL": "99",
	"priceCOMPACT": "149",
	"maxUsageCountTitle": "Paketin kuukausilimiitti:",
	"maxUsageCountMICRO": "20",
	"maxUsageCountSMALL": "40",
	"maxUsageCountCOMPACT": "60",
	"subscriptionPeriodTitle": "Tilausjakso:",
	"subscriptionPeriodContent": "1 kk jatkuva tilaus",
	"packageSelectionTerms1": "Sopimus on voimassa kolme (3) kuukautta, jonka jälkeen se jatkuu toistaiseksi voimassaolevana. Palvelumaksu ja erikseen ostetut lisäraportit laskutetaan kuukausittain. 3 kk:n sopimusjakson jälkeen irtisanomisaika on yksi (1) kuukausi.",
	"packageSelectionTerms2": "Kuukausihinta sisältää limiitin verran raportteja verkkopalvelussa ja limiitin ylittävät haut veloitetaan voimassa olevan hinnaston mukaan.",
	"packageSelectionTerms3": "Mobiilisovelluksessa tehdyt haut veloitetaan voimassa olevan hinnaston mukaan. Käytössäsi on myös lisämaksullisia palveluita, joista laskutetaan käytön mukaan.",
	"month": "kk",
	"orderInfoTitle": "Tilaajan tiedot",
	"billingInfoTitle": "Laskutustiedot",
	"billingTypeONLINE": "Verkkolasku",
	"billingTypeEMAIL": "Sähköpostilasku",
	"billingTypePAPER": "Paperilasku",
	"onlineBillingAddress": "Verkkolaskuosoite",
	"billingLanguage": "Laskun kieli",
	"billingLanguageFI": "Suomi",
	"billingLanguageSV": "Ruotsi",
	"billingLanguageEN": "Englanti",
	"billingAddressSame": "Laskutusosoite on sama kuin yrityksen postiosoite",
	"billingStreetAddress": "Laskutusosoite",
	"subscriberInfo": "Tilaajan/yhteyshenkilön tiedot",
	"usersTitle": "Käyttäjät",
	"usersInfo": "Voit antaa palveluun 1-4 käyttäjän tiedot. Jos tarvitset useampia käyttäjätunnuksia, saat ne asiakaspalvelustamme.",
	"createUserAccountForSubscriber": "Haluan käyttäjätunnuksen tilaajalle/yhteyshenkilölle",
	"notUniqueEmail": "Sähköpostin täytyy olla yksilöllinen",
	"atLeastOneUser": "Vähintään yhden käyttäjän tiedot on syötettävä",
	"summaryTitle": "Yhteenveto",
	"billingMethod": "Laskutustapa",
	"chosenPackage": "Valittu palvelupaketti",
	"contractContentTitle": "Sopimuksen sisältö",
	"contractContent1": "Sopimus on voimassa kolme (3) kuukautta,  jonka jälkeen se jatkuu toistaiseksi voimassaolevana. Palvelumaksu ja tai lisäraportit laskutetaan kuukausittain. Irtisanomisaika on yksi (1) kuukausi.",
	"contractContent2": "Kuukausihinta sisältää limiitin verran raportteja verkkopalvelussa ja limiitin ylittävät haut veloitetaan voimassa olevan hinnaston mukaan.",
	"contractContent3": "Mobiilisovelluksessa tehdyt haut veloitetaan voimassa olevan hinnaston mukaan. Käytössäsi on myös lisämaksullisia palveluita, joista laskutetaan käytön mukaan.",
	"servicePackageContentTitle": "Palvelupaketin sisältö",
	"servicePackageContent1": "Uuden asiakkaan tarkastus",
	"servicePackageContent2": "Luottolimiitin korotus",
	"servicePackageContent3": "Maksuvaikeuksien selvitys",
	"servicePackageContent4": "Tilinpäätöksen arviointi",
	"servicePackageContent5": "Konsernitiedot, tilinpäätökset",
	"servicePackageContent6": "Hankinnan toimittajatarkastus",
	"servicePackageContent7": "Henkilön riskiarviointi",
	"servicePackageContent8": "Käytössäsi on myös Mobiilisovellus, jossa tehdyt yritystietohaut veloitetaan voimassa olevan hinnaston mukaan",
	"termsTitle": "Sopimusehdot",
	"termsText": "Yleiset sopimusehdot",
	"acceptTerms": "Hyväksyn sopimusehdot ja vahvistan tilauksen",
	"confirmOrder": "Vahvista tilaus",
	"mustAcceptTerms": "Sopimusehdot pitää hyväksyä",
	"orderFailed": "Rekisteröinti epäonnistui!",
	"formInvalid": "Virhe lomakkeen tiedoissa.",
	"finishedTitle": "Kiitos tilauksestasi!",
	"finishedText1": "Tilauksesi on valmis ja tilausvahvistus toimitetaan tilaajan sähköpostiosoitteeseen. Palvelun käyttäjätunnukset ja salasanat toimitetaan sähköpostitse tilauksella annettuihin sähköpostiosoitteisiin.",
	"finishedText2": "Tilaukseesi liittyvissä asioissa asiakaspalvelumme palvelee sinua arkisin klo 9.00 - 16.00:",
	"finishedText3": "puh. 010 270 7200 ja asiakaspalvelu@asiakastieto.fi"
} as const;

export type translationKey = keyof typeof fiTranslations;

const enTranslations: Record<translationKey, string> = {
	"title": "Service Package Order",
	"companyBasicInformationTitle": "Company basics",
	"thanYouForContacting": "Thank you for contacting us, we will contact you soon!",
	"previous": "Previous",
	"next": "Next",
	"cancel": "Cancel",
	"continueOrder": "Continue the order",
	"cancelConfirmationTitle": "You are about to cancel your order. Cancelling will delete all data.",
	"cancelConfirmationQuestion": "Are you sure you want to cancel your order?",
	"return": "Return",
	"returnToAsiakastieto": "Return to Asiakastieto's pages",
	"continue": "Continue",
	"send": "Send",
	"unexpectedError": "Error situation",
	"formDataLoadingFailed": "Failed to load form data.",
	"companyCheckFailed": "Failed to check company information.",
	"requiredField": "Required field",
	"invalidEmail": "Invalid email address",
	"emailsDontMatch": "Emails do not match",
	"companyName": "Company name",
	"companyId": "Business ID",
	"streetAddress": "Mailing address",
	"postalCode": "Postal code",
	"invalidPostalCode": "Invalid postal code",
	"city": "Postal district",
	"email": "Email address",
	"emailRepeat": "Repeat email address",
	"firstName": "First name",
	"lastName": "Last name",
	"phone": "Phone number",
	"invalidPhone": "Invalid phone number",
	"companySearchDiscontinued": "DISCONTINUED",
	"invalidCompanySelection": "Invalid company information",
	"companySearchLabel": "Company's name or business ID",
	"companyDiscontinued": "This company is discontinued",
	"companySearchPlaceholder": "Search by company name or Business ID...",
	"identificationTitle": "Identification",
	"companyCheckSuccess": "Please confirm the company's signing authority. Once you have authenticated, we can proceed to the service package selection phase.",
	"identify": "Identify",
	"identificationError": "Error in identification.",
	"tooHighCreditRiskTitle": "Thank you for contacting us. We appreciate your interest in our service.",
	"tooHighCreditRiskContent": "Unfortunately, our credit policy does not currently allow for ordering services on invoice. We apologize for any inconvenience caused. You can always purchase products from our <a href=\"https://www.asiakastieto.fi/yritykset\">online store</a> via direct debit.",
	"invalidCompanyText1": "We will contact you shortly",
	"invalidCompanyText2": "Unfortunately, we are unable to offer you a contract in the self-service channel, but our sales will be with you to provide you with a solution that meets your needs.",
	"invalidCompanyText3": "Fill in your contact information below and we will contact you",
	"invalidCompanyPleaseEnterContact": "Please provide your contact information and we will be in touch with you shortly.",
	"contactFormFailed": "Failed to submit contact request!",
	"checkNoSignatureRight": "Unfortunately, ordering is not possible because the signing authority is missing.",
	"checkExistingCustomer": "Thank you for your interest in our services. Unfortunately, ordering was not successful.",
	"checkActivityInterrupted": "Thank you for your interest in our services. The company's operations are suspended, so ordering is currently not possible.",
	"checkBankrupt": "Our credit policy does not allow for ordering.",
	"checkLiquidation": "Our credit policy does not allow for ordering.",
	"checkCompanyIndustry": "Thank you for your interest in our services. Unfortunately, the company's line of business does not allow for ordering this service. Please feel free to contact our customer service if you have any questions.",
	"checkTurnoverTooHigh": "Thank you for your interest in our services. We regret to inform you that the current offering may not be suitable for a company of your size.",
	"checkCompanyRegistrationIncomplete": "Thank you for your interest in our services. The company's registration is still pending, so ordering is not possible at this time. Please try again later.",
	"checkCreditRisk": "Our credit policy does not allow for ordering. Please feel free to contact our customer service if you have any questions.",
	"naviUsage": "Usage",
	"naviBasketSelection": "Service package selection",
	"naviOrderInfo": "Customer information",
	"naviSummary": "Order summary",
	"naviFinished": "Order completed",
	"packageSelectionTitle": "Please select a package according to your needs by choosing a monthly limit",
	"packageSelectionContent": "The monthly limit indicates the number of searches per month (20, 40, or 60). If you need more reports during the subscription period than your chosen package allows, you can purchase these at a different rate.",
	"typeMICRO": "Micro",
	"typeSMALL": "Small",
	"typeCOMPACT": "Compact",
	"priceMICRO": "49",
	"priceSMALL": "99",
	"priceCOMPACT": "149",
	"maxUsageCountTitle": "Package monthly limit:",
	"maxUsageCountMICRO": "20",
	"maxUsageCountSMALL": "40",
	"maxUsageCountCOMPACT": "60",
	"subscriptionPeriodTitle": "Subscription period:",
	"subscriptionPeriodContent": "1 month continuous subscription",
	"packageSelectionTerms1": "The contract is valid for three (3) months, after which it continues indefinitely. Service fees and separately purchased additional reports are invoiced monthly. After the 3-month contract period, the notice period is one (1) month.",
	"packageSelectionTerms2": "The monthly price includes a limit of reports in the online service, and searches exceeding the limit will be charged according to the current price list.",
	"packageSelectionTerms3": "Searches made in the mobile application will be charged according to the current price list. There are also additional paid services available, which will be invoiced based on usage.",
	"month": "month",
	"orderInfoTitle": "Customer information",
	"billingInfoTitle": "Invoicing information",
	"billingTypeONLINE": "E-invoice",
	"billingTypeEMAIL": "Email invoice",
	"billingTypePAPER": "Paper invoice",
	"onlineBillingAddress": "E-invoice address",
	"billingLanguage": "Invoice language",
	"billingLanguageFI": "Finnish",
	"billingLanguageSV": "Swedish",
	"billingLanguageEN": "English",
	"billingAddressSame": "The billing address is the same as the business mailing address",
	"billingStreetAddress": "Billing address",
	"subscriberInfo": "Subscriber/contact person information",
	"usersTitle": "Users",
	"usersInfo": "You can enter 1-4 users' information in the service below. If you need more user accounts please contact our customer service.",
	"createUserAccountForSubscriber": "I want the subscriber/contact person to obtain the username",
	"notUniqueEmail": "Email addresses must be unique",
	"atLeastOneUser": "Data for at least one user must be entered",
	"summaryTitle": "Summary",
	"billingMethod": "Billing method",
	"chosenPackage": "Chosen service package",
	"contractContentTitle": "Contract content",
	"contractContent1": "The contract is valid for three (3) months, after which it continues indefinitely. Service fees and/or additional reports are invoiced monthly. The notice period is one (1) month.",
	"contractContent2": "The monthly price includes a limit of reports in the online service, and searches exceeding the limit will be charged according to the current price list.",
	"contractContent3": "Searches made in the mobile application will be charged according to the current price list. There are also additional paid services available, which will be invoiced based on usage.",
	"servicePackageContentTitle": "Service package content",
	"servicePackageContent1": "New customer check",
	"servicePackageContent2": "Credit limit increase",
	"servicePackageContent3": "Investigation of payment difficulties",
	"servicePackageContent4": "Evaluation of financial statements",
	"servicePackageContent5": "Group information, financial statements",
	"servicePackageContent6": "Supplier check for procurement",
	"servicePackageContent7": "Risk assessment of individuals",
	"servicePackageContent8": "You also have access to the Mobile Application, where searches for company information are charged according to the current price list",
	"termsTitle": "Terms and conditions",
	"termsText": "Common terms",
	"acceptTerms": "I accept the Terms and Conditions and confirm the order",
	"confirmOrder": "Confirm order",
	"mustAcceptTerms": "The terms of the contract must be accepted",
	"orderFailed": "Registration failed!",
	"formInvalid": "Invalid form values.",
	"finishedTitle": "Thank you for your order",
	"finishedText1": "Your order is complete and the order confirmation will be sent to the subscriber's email address. The usernames and passwords of the service will be sent by e-mail to the e-mail addresses provided in the order.",
	"finishedText2": "In matters related to your order, our customer service will serve you on weekdays from 9:00 to 16:00:",
	"finishedText3": "tel. 010 270 7200 ja asiakaspalvelu@asiakastieto.fi"
} as const;

const translations = {
	"fi": {
		"translation": fiTranslations
	},
	"en": {
		"translation": enTranslations
	}
} as const;

export default translations;
